import schema from './validation';

const horsePowerRegexps = [/\(\d{2,3}\s*[Hh]\s*[Pp]\)/, /\(\d{2,3}\s*(л.)\s*(с.)\)/];
const regexpNumber = /\d+/;

export const parseEnginePower = (str) => {
  const executed = horsePowerRegexps.reduce((acc, regexp) => {
    return acc ? acc : regexp.exec(str);
  }, null);

  if (executed === null) {
    return '';
  }

  return Number(regexpNumber.exec(executed[0])[0]);
};

export const prepareCarInstanceData = (carInstance) => {
  try {
    return schema.validateSync(carInstance);
  } catch (error) {
    return carInstance;
  }
};

/**
 * @typedef {object} CarEquipmentRead
 * @property {number} actionPrice
 * @property {string} code
 * @property {number} [discount]
 * @property {number} [discountDirect]
 * @property {string} engine
 * @property {number} id
 * @property {number} modelId
 * @property {string} name
 * @property {string} name1
 * @property {number} price
 * @property {string} transmission
 * */
/**
 * @typedef {object} FindVersionParams
 * @property {string} [version]
 * @property {CarEquipmentRead[]} [versions]
 * */
/**
 * @param {FindVersionParams} params
 * @return {CarEquipmentRead | undefined}
 * */
export const findVersion = ({ version, versions }) => {
  if (typeof version !== 'string' || !Array.isArray(versions)) {
    return;
  }

  return versions.find(({ name }) => {
    if (typeof name !== 'string') {
      return;
    }

    return version.trim() === name.trim();
  });
};
